import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, WAREHOUSES } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import AddSenderLocationForm from './AddSenderLocationForm';

const SenderLocations = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', width: 60, filterType: FilterType.number, show: false },
			{
				Header: 'locationName',
				accessor: 'locationName',
				width: 110,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.WAREHOUSES,
				showOnMobile: true,
				showOnMap: true
			},
			{
				Header: 'fullName',
				accessor: 'fullName',
				width: 110,
				filterType: FilterType.string,
				showOnMobile: true,
				showOnMap: true
			},
			{
				Header: 'mobileNumber',
				accessor: 'phone',
				width: 120,
				filterType: FilterType.string,
				renderCell: ListComponents.PHONE,
				showOnMap: true
			},
			{
				Header: 'email',
				accessor: 'email',
				width: 140,
				filterType: FilterType.string,
				show: false,
				showOnMap: true
			},
			{
				Header: 'country',
				accessor: 'countryName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 80,
				show: false
			},
			{ Header: 'city', accessor: 'cityName', width: 80, filterType: FilterType.multiSelection },
			{ Header: 'address', accessor: 'address', width: 140, filterType: FilterType.string, showOnMap: true },
			{
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				width: 100,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ACTIVE_INACTIVE,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				title="senderLocations"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/warehouse-icon.json.gz">
				<Button
					label="addSenderLocation"
					variant="blue"
					className="addButton"
					lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
					icon={faPlus}
					onClick={() => NiceModal.show(AddSenderLocationForm)}
				/>
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.SENDER_LOCATIONS}
				columns={columns}
				fetchUrl={WAREHOUSES.GET_SENDER_LOCATIONS_LIST}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.WAREHOUSE}
				exportName="senderLocations"
				showMapViewButton
			/>
		</div>
	);
};

export default SenderLocations;
